module.exports = __webpack_public_path__ + "static/success-dc23dc7ebef405abe1338af23a47f3d2.png";